import $ from "jquery";
window.$ = $;
window.jQuery = $;

// Vendors (same order as CodeKit)
import "./library/modernizr.js";
import "../components/slick-carousel/slick/slick.min.js";
import "./library/photoswipe/photoswipe.js";
import "./library/photoswipe/photoswipe-ui-default.js";
import "./library/zoom.js";
import Tablesort from "../components/tablesort/dist/tablesort.min.js";
window.Tablesort = Tablesort;
require("../components/tablesort/dist/sorts/tablesort.number.min.js");

// Your partials (same order as CodeKit)
import "./partials/_acf.js";
import "./partials/_base.js";
